"use client";

import { FLOORS, PROPERTY_TYPES } from "@/features/quote/shared/quote-config";
import { StepHeading } from "@/features/quote/ui/StepHeading";
import { StepNav } from "@/features/quote/ui/StepNav";
import { useStep, useWizard } from "@/features/quote/ui/wizard-context";
import { labelClass } from "@/shared/ui/form/field-styles";
import { RadioCards } from "@/shared/ui/form/RadioCards";

export function PropertyStep() {
  const { autoAdvance, next, back, canAdvance, bbrPrefilled, clearBbrPrefilled } = useWizard();
  const [{ propertyType = "", floor = "" }, answer] = useStep("property");

  return (
    <section>
      <StepHeading
        title="Hvilken type bolig?"
        body="Det hjælper os med at matche dig med firmaer der har erfaring med din boligtype."
      />
      <RadioCards
        options={PROPERTY_TYPES}
        value={propertyType}
        onChange={(v) => {
          answer({ propertyType: v });
          clearBbrPrefilled("propertyType");
          if (v !== "lejlighed") autoAdvance();
        }}
      />
      {bbrPrefilled.propertyType && (
        <p className="mt-2 text-[13px] text-ink-subtle">Hentet fra BBR - ret hvis nødvendigt.</p>
      )}

      {propertyType === "lejlighed" && (
        <div className="mt-8">
          <div className={labelClass}>Hvilken etage?</div>
          <RadioCards
            options={FLOORS}
            value={floor}
            onChange={(v) => {
              answer({ floor: v });
              clearBbrPrefilled("floor");
              autoAdvance();
            }}
            gridClassName="grid-cols-2 sm:grid-cols-3"
          />
          {bbrPrefilled.floor && (
            <p className="mt-2 text-[13px] text-ink-subtle">
              Hentet fra BBR - ret hvis nødvendigt.
            </p>
          )}
        </div>
      )}

      <StepNav onBack={back} onNext={next} nextEnabled={canAdvance} nextLabel="Næste →" />
    </section>
  );
}
